import styled from "styled-components";

export const Container = styled.div`
`;

export const Content = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding: 2rem 0rem 3rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 2rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    color: ${props => props.theme['text-title']};
    margin-bottom: 2rem;
  }
  
  span {
    text-align: center;
    margin: 0rem 4rem 4rem 3rem;
    
    font-size: 1.5rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;

    color: ${props => props.theme['text-body']};
  }
`;

// --------------------------------------------------------------------------------------------------

export const CardsContainer = styled.div`
  display: grid;  
  grid-column-gap: 2rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 1450px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 730px) { grid-template-columns: repeat(1, 1fr); }
`;

// --------------------------------------------------------------------------------------------------

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;

  max-height: auto;
  width: 320px;
  @media (max-width: 450px) {
    width: 300px;
  }
  
  box-shadow: ${props => `2px 2px 10px rgba(1, 3, 10, ${props.theme.shadowOpacity})`};
  border-radius: 20px;

  img {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    object-fit: cover;
    width: 100%;
    height: 220px;

    @media (max-width: 370px) {
      height: 150px;
    }
  }

  p {
    margin: 0.5rem 0;
    font-size: 1rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 300;
    
    &.title {
      font-size: 1.5rem;
      align-self: center;
      color: ${props => props.theme['text-title']};
    }
    &.description { color: ${props => props.theme['text-body']}; }
    &.techs { color: ${props => props.theme['text-techs']}; }
  }

  div {
    &.card-texts-container {
      padding: 0.5rem 1.5rem 1.5rem;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;

    }

    &.card-links-container {
      padding: 0.5rem 1.5rem 1.5rem;
      margin-top: 1.5rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: row;
      justify-self: flex-end;
      margin-top: auto;
    }

    img {
      height: 20px;
      width: 20px;
      margin: 0 5px 0 0;
    }

    a {
      font-size: 1rem;
      font-family: 'Poppins', sans-serif;
      font-weight: 400;
      color: ${props => props.theme["text-title"]};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      } 
    }  
  }
`;